<template>
  <section class="users section">
    <div class="container">
      <h1 class="title">Edit User</h1>
      <loading v-if="loading" class="white-bg shadow-card" />
      <div class="card shadow-card" v-if="!loading && user">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>First Name</label>
                <input
                  type="text"
                  v-model.trim="user.first"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  v-model.trim="user.last"
                  class="form-control"
                />
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Email</label>
            <input
              type="email"
              autocomplete="off"
              v-model="user.email"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label>Password</label>
            <input
              type="password"
              autocomplete="off"
              v-model="user.password"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              :key="user.email"
              v-model="user.phone"
              v-cleave="cleave.phone"
              class="form-control"
              minlength="10"
            />
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Occupation</label>
                <select
                  id="occupation"
                  :disabled="loading"
                  v-model="user.occupation_id"
                  class="form-control"
                  placeholder="Occupation"
                >
                  <option :value="null">Select An Occupation</option>
                  <option
                    :value="o.id"
                    v-for="o in occupations.data"
                    :key="o.id"
                  >
                    {{ o.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Account Type</label>
                <select class="form-control" v-model="user.role">
                  <option
                    v-for="(s, i) in users.roles"
                    :key="i"
                    :value="s.key"
                    v-text="s.label"
                  ></option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Status</label>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="customSwitch1"
                v-model="user.active"
              />
              <label
                class="custom-control-label cursor-pointer"
                for="customSwitch1"
              >
                <badge
                  type="pill"
                  :color="user.active ? 'success' : 'danger'"
                  v-html="user.active ? 'Active' : 'Inactive'"
                ></badge>
              </label>
            </div>
          </div>
          <div class="form-group">
            <label>Receive Notifications Via</label>
            <div class="d-flex mb-5">
              <div class="custom-control custom-switch ml-3 mr-5">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="sendingSMS"
                  v-model="user.enable_sending_sms"
                />
                <label
                  class="custom-control-label cursor-pointer"
                  for="sendingSMS"
                  >SMS</label
                >
              </div>
              <div class="custom-control custom-switch ml-5">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="sendingEmail"
                  v-model="user.enable_sending_email"
                />
                <label
                  class="custom-control-label cursor-pointer"
                  for="sendingEmail"
                  >Email</label
                >
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <button
              @click="doUpdateUser"
              :disabled="saving"
              class="btn btn-primary btn-block btn-300"
            >
              <span v-if="!saving">Update User</span>
              <span
                class="spinner-border spinner-border-sm"
                v-if="saving"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "UserEdit",
  data() {
    return {
      cleave: {
        phone: { blocks: [3, 3, 4], delimiter: "-", numericOnly: true },
      },
    };
  },
  computed: {
    ...mapState(["saving", "loading", "users", "occupations"]),
    user: function () {
      return this.users.user;
    },
    id: function () {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.$store.commit("SET_LOADING_STATE", true, { root: true });
    this.$store.dispatch("occupations/all");
    this.$store.dispatch("users/get", this.id);
  },
  methods: {
    updateUser: function () {
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      this.$store.dispatch("users/update", { id: this.id, data: this.user });
    },
    doUpdateUser: function () {
      this.errors = [];
      if (this.user.first == "") {
        this.errors.push("First Name is required");
      }

      if (this.user.last == "") {
        this.errors.push("Last Name is required");
      }

      if (this.user.email == "") {
        this.errors.push("Email is required");
      }
      if (this.user.password && this.user.password.length < 8) {
        this.errors.push("The password must be at least 8 characters.");
      }
      if (this.user.phone == "") {
        this.errors.push("Phone is required");
      }
      if (this.user.phone !== "" && this.user.phone.length < 12) {
        this.errors.push("The phone must be at least 10 digits.");
      }

      if (this.errors.length <= 0) {
        if (this.user.isVendor && this.user.role == "CLIENT") {
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success ml-4",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
          });
          swalWithBootstrapButtons
            .fire({
              title: "Are you sure?",
              text: "You are trying to change the type for this user from Vendor to Client. Thus, the contact relations will be removed!",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, change",
              cancelButtonText: "No, cancel!",
              reverseButtons: true,
            })
            .then((result) => {
              if (result.value) {
                this.updateUser();
              }
            });
        } else if (!this.user.isVendor && this.user.role == "VENDOR") {
          return Swal.fire({
            title: "Error",
            text: "User should be a contact for at least one vendor, once the user is added; the type will be changed automatically to vendor",
            type: "error",
          });
        } else {
          this.updateUser();
        }
      } else {
        let msg = this.errors.join("<br>");
        this.$store.dispatch(
          "setError",
          { message: msg, title: "Errors Occurred" },
          { root: true }
        );
        this.errors = [];
      }
    },
  },
};
</script>
